import {Product} from '../types/product'

export type BoxWithCompartmentProducts = {
  id: string
  name: string
  compartments: Array<{
    product?: {id: string; name?: string} | null
  }>
}

export type ProductsInBoxesData = Record<
  string,
  {
    product: Product
    boxes: Array<{id: string; name: string}>
  }
>

export const createProductsInBoxes = (products: Product[], boxes: BoxWithCompartmentProducts[]): ProductsInBoxesData => {
  const data: ProductsInBoxesData = {}

  for (const product of products) {
    data[product.id] = {
      product,
      boxes: [],
    }
  }

  const sortedBoxes = boxes.slice().sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))

  for (const box of sortedBoxes) {
    for (const compartment of box.compartments ?? []) {
      const product = compartment.product
      if (!product) continue

      const entry = data[product.id]
      if (!entry) continue

      if (!entry.boxes.some((b) => b.id === box.id)) {
        entry.boxes.push({id: box.id, name: box.name})
      }
    }
  }

  return data
}
